export { OtherRooms, ROW_DISPLAY_COUNT } from './index.pc'
export { MobileOtherRooms } from './index.mobile'
